import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake } from "lucide-react";
import { Reveal, MaskedLine } from "./Reveal";
import { GIVING_URL } from "../lib/constants";

export const PageHero = ({ eyebrow, lines, lede, image, imageAlt }) => (
  <header className="grain relative overflow-hidden bg-cream honeycomb-bg">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 pb-16 pt-32 sm:px-6 lg:grid-cols-12 lg:items-center lg:px-12 lg:pb-24 lg:pt-40">
      <div className="lg:col-span-7">
        <span className="eyebrow" data-testid="page-eyebrow">{eyebrow}</span>
        <h1 className="font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-charcoal sm:text-5xl lg:text-6xl">
          {lines.map((l, i) => (
            <MaskedLine key={i} delay={0.12 * i}>{l}</MaskedLine>
          ))}
        </h1>
        {lede && (
          <Reveal delay={0.45}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-charcoal/70 sm:text-lg">{lede}</p>
          </Reveal>
        )}
      </div>
      {image && (
        <Reveal delay={0.3} className="lg:col-span-5">
          <div className="arch-frame relative overflow-hidden border-4 border-white shadow-2xl shadow-wing/15">
            <img src={image} alt={imageAlt || ""} className="aspect-[4/5] w-full object-cover" loading="eager" />
          </div>
        </Reveal>
      )}
    </div>
  </header>
);

export const CTABand = ({ title, text, primaryLabel = "Begin Your Journey", primaryTo = "/get-involved" }) => (
  <section className="grain relative overflow-hidden bg-wing py-20 lg:py-24" data-testid="cta-band">
    <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-pollen/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-garden/30 blur-3xl" />
    <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
      <Reveal>
        <HeartHandshake className="mx-auto mb-6 h-10 w-10 text-pollen" aria-hidden="true" />
        <h2 className="font-serif text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl">{title}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-white/80">{text}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to={primaryTo} className="btn-pollen" data-testid="cta-primary-btn">
            {primaryLabel} <ArrowRight className="h-4 w-4" aria-hidden="true" />
          </Link>
          <a href={GIVING_URL} target="_blank" rel="noopener noreferrer" className="btn-outline-light" data-testid="cta-donate-btn">
            Give Today
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export const SectionHead = ({ eyebrow, title, text, center = false }) => (
  <Reveal className={center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    <span className="eyebrow">{eyebrow}</span>
    <h2 className="font-serif text-3xl font-medium tracking-tight text-charcoal sm:text-4xl lg:text-5xl">{title}</h2>
    {text && <p className="mt-4 text-base leading-relaxed text-charcoal/70 sm:text-lg">{text}</p>}
  </Reveal>
);
